import { memo, useEffect, useState } from "react";
import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import HusibuechContent from "./HusibuechContent";
import { HusibuechContext } from "./context/husibuechContext";
import LoadingDashboardContent from "../../2_ksbHub/utils/loading/LoadingDashboardContent";
import { useAppContext } from "../../2_ksbHub/context/appContext";
import { loadDataForUser } from "./HusibuechHelpers/1_Functions/loadDataForUser";
import ActivationForm from "./HusibuechComponents/10_ActivationForm/ActivationForm";

function Husibuech() {
  const { loggingOut, currentUser, husibuechLoading, setHusibuechLoading } =
    useAppContext();

  // ✅ Core state only
  const [roles, setRoles] = useState({
    isStudent: false,
    isTeacher: false,
    isAdmin: false,
    isLeader: false,
  });

  const [data, setData] = useState({
    courses: [],
    selectedCourse: null,
    subjects: [],
    coreCourses: [],
    holidays: [],
    examTypes: [],
  });

  const [ui, setUi] = useState({
    showActivationForm: false,
    personalView: false,
  });

  // ✅ derive roles once
  useEffect(() => {
    if (!currentUser?.roles) return;

    const isStudent = currentUser.roles.includes("Student");
    const isTeacher = currentUser.roles.includes("Teacher");
    const isAdmin = currentUser.roles.includes("Admin");

    setRoles({
      isStudent,
      isTeacher,
      isAdmin,
      isLeader: isTeacher || isAdmin,
    });

    if (isStudent) {
      setUi((prev) => ({ ...prev, personalView: true }));
    }
  }, [currentUser]);

  // ✅ load user data
  useEffect(() => {
    if (!husibuechLoading || !currentUser) return;

    const load = async () => {
      try {
        await loadDataForUser(
          currentUser,
          null,
          null,
          (value) => setUi((prev) => ({ ...prev, showActivationForm: value })),
          (value) => setData((prev) => ({ ...prev, holidays: value })),
          (value) => setData((prev) => ({ ...prev, coreCourses: value })),
          null,
          null,
          null,
          (value) => setData((prev) => ({ ...prev, subjects: value })),
          null,
          null,
          (value) => setData((prev) => ({ ...prev, courses: value })),
          (value) => setData((prev) => ({ ...prev, coreCourses: value })),
          (value) => setData((prev) => ({ ...prev, subjects: value })),
          (value) => setData((prev) => ({ ...prev, courses: value })),
          (value) => setData((prev) => ({ ...prev, examTypes: value })),
        );
      } catch (err) {
        console.error("Error loading user data", err);
      } finally {
        setHusibuechLoading(false);
      }
    };

    load();
  }, [husibuechLoading, currentUser, setHusibuechLoading]);

  // ✅ select first course automatically
  useEffect(() => {
    if (data.courses?.length) {
      setData((prev) => ({
        ...prev,
        selectedCourse: prev.selectedCourse || prev.courses[0],
      }));
    }
  }, [data.courses]);

  // ✅ reset on logout
  useEffect(() => {
    if (!loggingOut) return;

    setRoles({
      isStudent: false,
      isTeacher: false,
      isAdmin: false,
      isLeader: false,
    });

    setData({
      courses: [],
      selectedCourse: null,
      subjects: [],
      coreCourses: [],
      holidays: [],
      examTypes: [],
    });

    setUi({
      showActivationForm: false,
      personalView: false,
    });
  }, [loggingOut]);

  return (
    <div className="content">
      <HusibuechContext.Provider
        value={{
          ...roles,
          ...data,
          ...ui,
        }}
      >
        <TemplatePage type="husibuech">
          <>
            <ActivationForm />

            {husibuechLoading ? (
              <LoadingDashboardContent />
            ) : (
              <HusibuechContent />
            )}
          </>
        </TemplatePage>
      </HusibuechContext.Provider>
    </div>
  );
}

export default memo(Husibuech);
